import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { get } from 'jquery';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ApiService } from 'src/app/shared/_service/api.service';
import { KePackDataModel } from './container-canvas/KePackDataModel';

@Component({
	selector: 'app-edit-container',
	templateUrl: './edit-container.component.html',
})
export class EditContainerComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private api: ApiService,
		private auth: AuthService,
		private modalService: NgbModal,
	) {}

	@ViewChild('alertModal', { static: true }) alertModal: ElementRef;

	modal: NgbModalRef;

	idSpedizione: number;
	spedizione: any;
	container: any;
	kePackDataModel: any;
	selectedItemKePack: any;
	listaConfigurazioneProdottoContainer: any[];
	listaGruppiConfigurazioneProdottoContainer: any[];

	listaTipoContainer = [];
	prodottiDiAltriOrdini = [];

	containerNumber;
	alertModalTitle = '';
	alertModalMessage = '';

	readOnly = false;
	openLayoutPdf = false;
	showPrint = false;
	showLoading = false;

	dimensioneDefaultNullValue = 1000;
	defaultSovrapponibilita = 8;

	get toInsertQty() {
		if (!this.spedizione || this.spedizione.prodottiRimanenti?.length === 0) {
			return 0;
		}
		return this.spedizione.prodottiRimanenti.map((p) => p.quantita).reduce((prev, qta) => (prev += qta));
	}

	get insertedQty() {
		if (!this.container || this.container.prodottiInseriti?.length === 0) {
			return 0;
		}
		return this.container.prodottiInseriti.map((p) => p.quantita).reduce((prev, qta) => (prev += qta));
	}

	get shipmentQty() {
		if (!this.spedizione || this.spedizione.prodottiRimanenti?.length === 0) {
			return 0;
		}
		return this.spedizione.prodottiRimanenti.map((p) => p.quantitaOriginale).reduce((prev, qta) => (prev += qta));
	}

	get $salvaSpedizione() {
		return this.api.saveSpedizione({
			...this.spedizione,
			idOrdine: this.spedizione.ordine ? this.spedizione.ordine.id : null,
			idSpedizione: this.spedizione.id,
		});
	}

	ngOnInit() {
		this.showLoading = true;

		this.route.params.subscribe((p) => {
			this.idSpedizione = p.id / 1;

			forkJoin([
				this.api.getListaTipoContainer(),
				this.api.getConfigurazioneProdottoContainer(),
				this.api.getGruppoConfigurazioneProdottoContainer(),
			]).subscribe(([listaTipoContainer, listaConfigurazioneProdottoContainer, listaGruppiConfigurazioneProdottoContainer]) => {
				this.listaTipoContainer = listaTipoContainer;
				this.listaConfigurazioneProdottoContainer = listaConfigurazioneProdottoContainer;
				this.listaGruppiConfigurazioneProdottoContainer = listaGruppiConfigurazioneProdottoContainer;
				this.updateSpedizione();
			});
		});
	}

	updateSpedizione() {
		this.api.getSpedizioneById({ idSpedizione: this.idSpedizione }).subscribe((spedizione: any) => {
			this.spedizione = spedizione;
			this.readOnly = this.auth.isSpedizioniere || (this.auth.isCliente && this.spedizione.chiusa);

			this.spedizione.prodottiRimanenti.forEach((prodotto) => {
				prodotto.quantitaDaInserire = prodotto.quantita;
				// prodotto.disabledForShipment = spedizione.tipoSpedizione === 'ORDINE_IN_SPEDIZIONE' && prodotto.prodottoCarrello.statoRigaOrdine !== 'IN_SHIPMENT';
			});
			if (this.spedizione.containers.length) {
				this.container = this.spedizione.containers[0];
				this.container.prodottiInseriti.forEach((prodotto) => {
					prodotto.quantitaDaRimuovere = prodotto.quantita;
				});
			}
			this.updateKePackDataModel();
			this.calcolaPercentualeRiempimento();
			this.showLoading = false;

			// Aspetto il caricamento del 3D per abilitare la stampa
			setTimeout(() => (this.showPrint = true), 1000);
		});
	}

	/************************************************ INTERAZIONE FRONT END *****************************************************/

	/** Chiamato al drop di un prodotto sul canvas del 3D */
	onDrop(event: CdkDragDrop<string[]>) {
		const idProdottoCommerciale = Number(event.item.element.nativeElement.id);
		const prodottoSpedizione = this.spedizione.prodottiRimanenti.find((p) => p.prodottoCommerciale.id === idProdottoCommerciale);
		this.aggiungiProdottoAlContainer(prodottoSpedizione);
	}

	/** Apre il layout di stampa */
	stampa() {
		this.openLayoutPdf = true;
	}

	/** Apre il modale di aggiunta container */
	openAddContainerModal(content) {
		this.modal = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
	}

	/** Apre il modale di aggiunta prodotto da un altro ordine */
	apriModaleAggiungiProdottoDaAltroOrdine(modalContent) {
		this.api.getProdottiContainerDaInserire({ idSpedizione: this.spedizione.id, idUtente: this.auth.getUser().id }).subscribe((res) => {
			this.prodottiDiAltriOrdini = res;
			this.modal = this.modalService.open(modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
		});
	}

	/** Controlla il valore inserito nell' input 'da inserire' */
	inputDaInserireChange(event, prodotto) {
		if (Number(event.target.value) < 1) {
			prodotto.quantitaDaInserire = 1;
		}
		if (Number(event.target.value) > prodotto.quantita) {
			prodotto.quantitaDaInserire = prodotto.quantita;
		}
	}

	/** Controlla il valore inserito nell' input 'da rimuovere' */
	inputDaRimuovereChange(event, prodotto) {
		if (Number(event.target.value) < 1) {
			prodotto.quantitaDaRimuovere = 1;
		}
		if (Number(event.target.value) > prodotto.quantita) {
			prodotto.quantitaDaRimuovere = prodotto.quantita;
		}
	}

	/** Cambia il container visualizzato */
	switchContainer(container) {
		this.containerNumber = this.spedizione.containers.indexOf(container);
		this.container = container;
		this.updateKePackDataModel();
	}

	/************************************************ INTERAZIONE CON IL CANVAS 3D *****************************************************/

	/** Seleziona ed illumina un prodotto nel canvas 3D */
	selezionaProdottoContainer(prodotto) {
		this.container.prodottiInseriti.filter((p) => p !== prodotto).forEach((p) => (p.selected = false));
		prodotto.selected = !prodotto.selected;
		this.selectedItemKePack = prodotto.selected
			? this.kePackDataModel.packagings.find((item) => item.code.technical === prodotto.prodottoCommerciale.codiceTecnico)
			: null;
	}

	/** Chiamato quando l' utente clicca su un collo sul 3D, seelziona il prodotto anche su interfaccia */
	prodottoSelezionatoDalCanvas(item) {
		if (this.container) {
			this.container.prodottiInseriti.forEach((p) => (p.selected = false));
			if (item) {
				const prodottoContainer = this.container.prodottiInseriti.find(
					(p) => p.prodottoCommerciale.codiceCommerciale === item.code.commercial,
				);
				prodottoContainer.selected = true;
			}
		}
	}

	/************************************************ AGGIUNTA/RIMOZIONE PRODOTTI E CONTAINER *****************************************************/

	/** Aggiunge il prodotto nella spedizione al container */
	aggiungiProdottoAlContainer(prodottoSpedizione: any) {
		// Recupero il relativo prodotto container
		const prodottoContainer = this.container.prodottiInseriti.find(
			(p) => p.prodottoCommerciale.id === prodottoSpedizione.prodottoCommerciale.id,
		);
		if (prodottoSpedizione && prodottoContainer) {
			// Riduco la quantita del prodotto spedizione e aggiungo la stessa quantita al prodotto conytainer
			prodottoSpedizione.quantita -= prodottoSpedizione.quantitaDaInserire;
			prodottoContainer.quantita += prodottoSpedizione.quantitaDaInserire;
			prodottoSpedizione.quantitaDaInserire = prodottoSpedizione.quantita;
			prodottoContainer.quantitaDaRimuovere = prodottoContainer.quantita;
			this.calcolaPercentualeRiempimento();

			// Eseguo gli aggiornamenti a DB
			this.showLoading = true;
			forkJoin([
				this.api.saveProdottoContainer({ idProdottoContainer: prodottoSpedizione.id, quantita: prodottoSpedizione.quantita }),
				this.api.saveProdottoContainer({ idProdottoContainer: prodottoContainer.id, quantita: prodottoContainer.quantita }),
				this.$salvaSpedizione,
			]).subscribe(() => {
				// Ricalcolo il container
				this.updateKePackDataModel();
				this.showLoading = false;
			});
		}
	}

	/** Rimuove il prodotto container dal container e lo sposta nella spedizione */
	rimuoviProdottoDalContainer(prodottoContainer: any) {
		// Recupero il relativo prodotto spedizione
		const prodottoSpedizione = this.spedizione.prodottiRimanenti.find(
			(p) => p.prodottoCommerciale.id === prodottoContainer.prodottoCommerciale.id,
		);
		// Riduco la quantita del prodotto container e aggiungo la stessa quantita al prodotto spedizione
		prodottoContainer.quantita -= prodottoContainer.quantitaDaRimuovere;
		prodottoSpedizione.quantita += prodottoContainer.quantitaDaRimuovere;
		prodottoSpedizione.quantitaDaInserire = prodottoSpedizione.quantita;
		prodottoContainer.quantitaDaRimuovere = prodottoContainer.quantita;
		this.calcolaPercentualeRiempimento();

		// Eseguo gli aggiornamenti a DB
		this.showLoading = true;
		forkJoin([
			this.api.saveProdottoContainer({ idProdottoContainer: prodottoSpedizione.id, quantita: prodottoSpedizione.quantita }),
			this.api.saveProdottoContainer({ idProdottoContainer: prodottoContainer.id, quantita: prodottoContainer.quantita }),
			this.$salvaSpedizione,
		]).subscribe(() => {
			// Ricalcolo il container
			this.updateKePackDataModel();
			this.showLoading = false;
		});
	}

	/** Aggiunge tutti i prodotti rimanenti nella spedizione al container */
	aggiungiTuttiProdottiAlContainer() {
		let updates = [];
		this.spedizione.prodottiRimanenti.forEach((prodottoSpedizione) => {
			const prodottoContainer = this.container.prodottiInseriti.find(
				(p) => p.prodottoCommerciale.id === prodottoSpedizione.prodottoCommerciale.id,
			);
			prodottoContainer.quantita += prodottoSpedizione.quantita;
			prodottoSpedizione.quantita = 0;
			prodottoSpedizione.quantitaDaInserire = prodottoSpedizione.quantita;
			prodottoContainer.quantitaDaRimuovere = prodottoContainer.quantita;
			updates = [
				...updates,
				{ idProdottoContainer: prodottoSpedizione.id, quantita: prodottoSpedizione.quantita },
				{ idProdottoContainer: prodottoContainer.id, quantita: prodottoContainer.quantita },
			];
		});

		this.calcolaPercentualeRiempimento();
		this.showLoading = true;
		forkJoin([this.api.saveProdottoContainerMultiplo(updates), this.$salvaSpedizione]).subscribe(() => {
			this.updateKePackDataModel();
			this.showLoading = false;
		});
	}

	/** Rimuove tutti i prodotti contenuti nel container selezionato e li inserisce nella spedizione */
	rimuoviTuttiProdottiDalContainer() {
		let updates = [];
		this.container.prodottiInseriti.forEach((prodottoContainer) => {
			const prodottoSpedizione = this.spedizione.prodottiRimanenti.find(
				(p) => p.prodottoCommerciale.id === prodottoContainer.prodottoCommerciale.id,
			);
			prodottoSpedizione.quantita += prodottoContainer.quantita;
			prodottoContainer.quantita = 0;
			prodottoSpedizione.quantitaDaInserire = prodottoSpedizione.quantita;
			prodottoContainer.quantitaDaRimuovere = prodottoContainer.quantita;
			updates = [
				...updates,
				{ idProdottoContainer: prodottoSpedizione.id, quantita: prodottoSpedizione.quantita },
				{ idProdottoContainer: prodottoContainer.id, quantita: prodottoContainer.quantita },
			];
		});

		this.calcolaPercentualeRiempimento();
		this.showLoading = true;
		forkJoin([this.api.saveProdottoContainerMultiplo(updates), this.$salvaSpedizione]).subscribe(() => {
			this.updateKePackDataModel();
			this.showLoading = false;
		});
	}

	/** Aggiunge alla spedizione attuale un prodotto container che fa parte di un altra spedizione */
	aggiungiProdottoDaAltraSpedizione(prodotto) {
		this.api
			.addProdottoContainerFromDifferentSpedizione({
				idProdottoContainer: prodotto.id,
				quantita: prodotto.quantitaDaInserire,
				idSpedizione: this.spedizione.id,
			})
			.subscribe((res) => {
				this.updateSpedizione();
				this.modalService.dismissAll();
			});
	}

	/** Rimuove dlla spedizione attuale un prodotto container che fa parte di un altra spedizione */
	rimuoviProdottoDaAltraSpedizione(prodotto) {
		this.api
			.removeProdottoContainerFromDifferentSpedizione({ idProdottoContainer: prodotto.id, quantita: prodotto.quantitaDaInserire })
			.subscribe((res) => {
				console.log(res);
			});
	}

	/** Aggiunge un nuovo container del tipo selezionato */
	aggiungiContainer(tipo) {
		this.api.addContainer({ idTipoContainer: tipo.id, idSpedizione: this.spedizione.id }).subscribe((container) => {
			this.container = container;
			this.spedizione.containers.push(container);
			this.updateKePackDataModel();
		});
		this.modal.close();
	}

	/** Rimuove il container attivo */
	rimuoviContainer() {
		if (this.container.prodottiInseriti.filter((p) => p.quantita > 0).length > 0) {
			this.alertModalTitle = 'Please remove all the packages before removing the container';
			this.alertModalMessage = undefined;
			return this.modalService.open(this.alertModal);
		}
		this.api.deleteContainer({ idContainer: this.container.id }).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.spedizione.containers.splice(this.spedizione.containers.indexOf(this.container), 1);
				this.container = this.spedizione.containers.length ? this.spedizione.containers[0] : null;
			}
		});
	}

	/************************************************ ELABORAZIONI E CALCOLI SUI COLLI *****************************************************/

	/** Calcola e imposta la percentuale di riempimento dei container e della spedizione */
	calcolaPercentualeRiempimento() {
		const percentualiContainer = [];
		this.spedizione.containers.forEach((container) => {
			const volumeContainer = container.tipoContainer.altezza * container.tipoContainer.larghezza * container.tipoContainer.profondita;
			let volumeColli = 0;
			container.prodottiInseriti.forEach((prodotto) => {
				volumeColli +=
					(prodotto.prodottoCommerciale.altezzaCollo || this.dimensioneDefaultNullValue / 10) *
					(prodotto.prodottoCommerciale.larghezzaCollo || this.dimensioneDefaultNullValue / 10) *
					(prodotto.prodottoCommerciale.profonditaCollo || this.dimensioneDefaultNullValue / 10) *
					prodotto.quantita;
			});
			const percentualeRiempimento = (volumeColli * 100) / volumeContainer;
			container.percentualeRiempimento = percentualeRiempimento;
			percentualiContainer.push(percentualeRiempimento);
		});

		this.spedizione.percentualeRiempimento =
			percentualiContainer.length > 0 ? percentualiContainer.reduce((a, b) => a + b) / percentualiContainer.length : 0;
		return this.spedizione.percentualeRiempimento;
	}

	/** Aggiorna i pacchetti del containerizzatore e triggera il calcolo della disposizione dei colli e l' aggiornamento del 3D */
	updateKePackDataModel() {
		if (!this.container) {
			return;
		}
		const kePackDataModel = new KePackDataModel();

		let prodotti = this.container.prodottiInseriti.filter((p) => p.quantita > 0);
		prodotti = this.elaboraGruppi(prodotti);

		prodotti.forEach((prodotto) => {
			let sovrapponibilita =
				this.findConfigurazione(prodotto.prodottoCommerciale.codiceTecnico, this.listaConfigurazioneProdottoContainer)?.sovrapponibilita ||
				this.defaultSovrapponibilita;
			if (prodotto.prodottoCommerciale.tipoImballo === 'FORK PALLET') {
				sovrapponibilita -= 1;
			}
			kePackDataModel.packagings.push({
				info: {
					name: prodotto.prodottoCommerciale.codiceCommerciale,
					type: prodotto.prodottoCommerciale.prodotto.tipo,
					color: this.packageColor(prodotto),
					count: prodotto.quantita,
					stackable: sovrapponibilita,
				},
				code: {
					technical: prodotto.prodottoCommerciale.codiceTecnico,
					commercial: prodotto.prodottoCommerciale.codiceCommerciale,
				},
				geometry: {
					height: (prodotto.prodottoCommerciale.altezzaCollo || this.dimensioneDefaultNullValue) / 10,
					width: (prodotto.prodottoCommerciale.larghezzaCollo || this.dimensioneDefaultNullValue) / 10,
					depth: (prodotto.prodottoCommerciale.profonditaCollo || this.dimensioneDefaultNullValue) / 10,
				},
				weight: {
					net: prodotto.prodottoCommerciale.pesoCollo || this.dimensioneDefaultNullValue,
					gross: prodotto.prodottoCommerciale.pesoCollo || this.dimensioneDefaultNullValue,
				},
				codiciCommercialiNelGruppo: prodotto.codiciCommercialiNelGruppo,
			});
		});

		kePackDataModel.containers.push({
			height: this.container.tipoContainer.altezza,
			length: this.container.tipoContainer.profondita,
			width: this.container.tipoContainer.larghezza,
			packagings: prodotti.map((_, index) => index),
			type: '',
		});

		this.kePackDataModel = kePackDataModel;
		console.log(kePackDataModel);
	}

	/** Gestisce la presenza di rimanenze che non possono essere inserite all' interno del container perchè non ci stanno */
	containerHasLeftovers(leftovers) {
		this.alertModalTitle = "There are product that doesn't fit in the container:";
		this.alertModalMessage = '- ' + leftovers.map((l) => l.codiceCommerciale).join('<br> -');
		this.modalService.open(this.alertModal);

		let updates = [];
		leftovers.forEach((leftover) => {
			const rimanenzeDaAggiornare = [];

			// Controllare che la rimanenza sia un prodotto singolo
			const prodottoKePack = this.kePackDataModel.packagings.find((pkp) => pkp.code.commercial === leftover.codiceCommerciale);
			if (prodottoKePack.codiciCommercialiNelGruppo && prodottoKePack.codiciCommercialiNelGruppo.length) {
				let quantitaDaRimuovere = leftover.quantita;
				prodottoKePack.codiciCommercialiNelGruppo.every((codiceCommerciale) => {
					const prodottoContainer = this.container.prodottiInseriti.find(
						(p) => p.prodottoCommerciale.codiceCommerciale === codiceCommerciale,
					);
					quantitaDaRimuovere -= prodottoContainer.quantita;
					rimanenzeDaAggiornare.push({
						codiceCommerciale: prodottoContainer.prodottoCommerciale.codiceCommerciale,
						quantita: quantitaDaRimuovere > 0 ? prodottoContainer.quantita : prodottoContainer.quantita + quantitaDaRimuovere,
					});
					if (quantitaDaRimuovere <= 0) {
						return false;
					}
					return true;
				});
			} else {
				// Se è un prodotto singolo eseguo gli update singolarmente
				rimanenzeDaAggiornare.push(leftover);
			}

			rimanenzeDaAggiornare.forEach((rimanenza) => {
				const prodottoContainer = this.container.prodottiInseriti.find(
					(p) => p.prodottoCommerciale.codiceCommerciale === rimanenza.codiceCommerciale,
				);
				const prodottoSpedizione = this.spedizione.prodottiRimanenti.find(
					(p) => p.prodottoCommerciale.codiceCommerciale === rimanenza.codiceCommerciale,
				);
				prodottoSpedizione.quantita += rimanenza.quantita;
				prodottoContainer.quantita -= rimanenza.quantita;
				prodottoSpedizione.quantitaDaInserire = prodottoSpedizione.quantita;
				prodottoContainer.quantitaDaRimuovere = prodottoContainer.quantita;
				updates = [
					...updates,
					{ idProdottoContainer: prodottoSpedizione.id, quantita: prodottoSpedizione.quantita },
					{ idProdottoContainer: prodottoContainer.id, quantita: prodottoContainer.quantita },
				];
			});
		});

		this.calcolaPercentualeRiempimento();
		forkJoin([this.api.saveProdottoContainerMultiplo(updates), this.$salvaSpedizione]).subscribe(() => this.updateKePackDataModel());
	}

	/* Prende un set di prodotti e unisce quelli facenti parte di un gruppo */
	elaboraGruppi(prodotti) {
		const prodottiSingoli = [];
		const gruppi = JSON.parse(JSON.stringify(this.listaGruppiConfigurazioneProdottoContainer)).map((g) => ({ ...g, prodotti: [] }));

		// Divido i prodotti singoli dai prodotti che possono essere raggruppati
		prodotti.forEach((prodotto) => {
			const gruppoTrovato = gruppi.find((gruppo) =>
				this.findConfigurazione(prodotto.prodottoCommerciale.codiceTecnico, gruppo.configurazioni),
			);

			if (gruppoTrovato) {
				gruppoTrovato.prodotti.push(prodotto);
			} else {
				prodottiSingoli.push(prodotto);
			}
		});

		//Unisco i prodotti nei gruppi e li faccio diventare prodotti singoli
		gruppi
			.filter((gruppo) => gruppo.prodotti.length)
			.forEach(({ prodotti }) => {
				// Aggiungo la quantita degli altri prodotti al primo della lista
				const prodottoRaggruppato = JSON.parse(JSON.stringify(prodotti.shift()));
				prodotti.forEach((p) => (prodottoRaggruppato.quantita += p.quantita));
				prodottoRaggruppato.codiciCommercialiNelGruppo = [
					prodottoRaggruppato.prodottoCommerciale.codiceCommerciale,
					...prodotti.map((p) => p.prodottoCommerciale.codiceCommerciale),
				];

				// Aggiungo il primo prodotto della lista (con la somma delle quantita del gruppo) ai prodotti singoli
				prodottiSingoli.push(prodottoRaggruppato);
			});

		return prodottiSingoli;
	}

	/* Trova la configurazione corrispondente ad un prodotto */
	findConfigurazione(codiceTecnico: string, configurazioni: any[]) {
		const configurazioniBase = configurazioni.filter((c) => codiceTecnico.toUpperCase().startsWith(c.codice.toUpperCase()));

		const configurazioni2Caratteri = configurazioniBase
			.filter((c) => c.terzoCarattere && c.ottavoCarattere)
			.filter((c) => codiceTecnico.charAt(2) === c.terzoCarattere)
			.filter((c) => codiceTecnico.charAt(7) === c.ottavoCarattere);

		const configurazioniTerzoCarattere = configurazioniBase
			.filter((c) => c.terzoCarattere)
			.filter((c) => codiceTecnico.charAt(2) === c.terzoCarattere);

		const configurazioniOttavoCarattere = configurazioniBase
			.filter((c) => c.ottavoCarattere)
			.filter((c) => codiceTecnico.charAt(7) === c.ottavoCarattere);

		return configurazioni2Caratteri[0] || configurazioniOttavoCarattere[0] || configurazioniTerzoCarattere[0] || configurazioniBase[0];
	}

	/************************************************ HELPERS *****************************************************/

	packageColor(prodotto) {
		if (!prodotto || !prodotto.prodottoCommerciale.prodotto || !prodotto.prodottoCommerciale.prodotto.tipo) {
			return '#ffffff';
		}
		switch (prodotto.prodottoCommerciale.prodotto.tipo) {
			case 'MC_P-CodLineaProdotto|05':
				return '#ff0000';
			case 'MC_P-CodLineaProdotto|10':
				return '#ffd500';
			case 'MC_P-CodLineaProdotto|15':
				return '#00ff3c';
			case 'MC_P-CodLineaProdotto|25':
				return '#00b7ff';
			case 'MC_P-CodLineaProdotto|45':
				return '#9000ff';
			case 'MC_P-CodLineaProdotto|80':
				return '#ff00dd';
			default:
				return '#ffffff';
		}
	}
}
